import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import ResidentsReducer from "../containers/ResidentsContainer/reducer";
import dashboardReducer from "../containers/DashboardContainer/reducer";
import DashboardReducer from "../containers/DefaultLayout/reducer";
import AlertsbReducer from "../containers/Alert_BContainer/reducer";
import purchaseReducer from "../containers/PurchaseContainer/reducer";
import SupportReducer from "../containers/SupportCondainer/reducer";
import myProfileReducer from "../containers/MyprofileContainer/reducer";
import SettingsReducer from "../containers/SettingsContainer/reducer";
import rwamemberReducer from "../containers/RwaContainer/reducer";
import ApartmentReducer from "../containers/ApartmentContainer/reducer";
import OnboardingResReducer from "../containers/Onboarding_residentsContainer/reducer";
import InvoiceReducer from "../containers/InvoiceContainer/reducer";
import OnboardingtwoReducer from "../containers/Onboarding2Container/reducer";
import ApprovedResidentsReducer from "../containers/ApprovedResidentsContainer/reducer";
import ResetReducer from "../containers/ResetPasswordContainer/reducer";
import logInReducer from "../containers/LoginContainer/reducer";

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    ResidentsReducer,
    dashboardReducer,
    DashboardReducer,
    AlertsbReducer,
    purchaseReducer,
    ApprovedResidentsReducer,
    SupportReducer,
    myProfileReducer,
    SettingsReducer,
    rwamemberReducer,
    ApartmentReducer,
    OnboardingtwoReducer,
    OnboardingResReducer,
    InvoiceReducer,
    ResetReducer,
    logInReducer,
  });

export default createRootReducer;
